import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import Layout from './Layout';

const queryClient = new QueryClient();

// if hitting the page as non subscriber, show locked homepage and only render header
const EnterprisePowerlist = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Layout />
    </QueryClientProvider>
  );
};

export default EnterprisePowerlist;
